import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, formValueSelector, SubmissionError, change, untouch } from "redux-form";
import _ from "lodash";
import { Link } from "react-router";
import Title from "../../components/Layout/Title";
import { toastr } from "react-redux-toastr";

import MaskDate from "../../components/Util/MaskDate";
import { ANALISE_IMAGEM_LOAD, ANALISE_IMAGEM_UNLOAD, UF_SYSTEM_LOAD, ANALISE_IMAGEM_ALL_COMPANIES_LOAD } from "../../actions/Constants";

import api from "../../api/apiUtil";
import SelectField from "../../components/Fields/SelectField";
import FieldValidation from "../../components/Validation/FieldValidation";
import TextDatePickerField from "../../components/Fields/TextDatePickerField";
import TextField from "../../components/Fields/TextField";
import FieldNormalize from "../../components/Normalize/FieldNormalize";
import TextareaField from "../../components/Fields/TextareaField";
import ReactTable from "react-table";
import { BeatLoader } from "react-spinners";
import fileDownload from "js-file-download";
import SvgIcon from "react-icons-kit";
import { wrench } from "react-icons-kit/icomoon/wrench";
import { fileExcelO } from "react-icons-kit/fa/fileExcelO";
import DropdownListField from "../../components/Fields/DropdownListField";
import * as FileSaver from "file-saver";
import XLSX from "xlsx/dist/xlsx.mini.min";

class AnaliseImagem extends React.Component {
  constructor() {
    super();
    this.state = {
      pesquisando: false,
      detalhar: null,
    };
  }

  componentDidMount() {
    this.props.onListLoad(api.Configuracao.getImagensAnalisadas());
    if (this.props.currentUser.perfis.some((item) => item == "ALIAS")) {
      this.props.onUfSystemLoad(api.Ufs.sigla_system());
      this.props.onCompaniesLoad(api.Financial.allFinancial());
    }
  }

  componentWillUnmount() {}

  validateForm(values) {
    // Verificar se algum campo foi preenchido
    const hasChassi = values.chassi && values.chassi.trim() !== "";
    const hasFinanceira = values.financeira && values.financeira !== "";
    const hasUf = values.uf && values.uf !== "";
    const hasFaixaScore = values.faixaScore && values.faixaScore !== "";
    const hasPeriodoInicio = values.periodoInicio && values.periodoInicio !== "";
    const hasPeriodoFim = values.periodoFim && values.periodoFim !== "";

    // Validação: deve ter pelo menos uma das combinações válidas
    const hasValidCombination =
      hasChassi || // Apenas chassi
      (hasFinanceira && hasPeriodoInicio && hasPeriodoFim) || // Financeira + Período
      (hasFinanceira && hasUf && hasPeriodoInicio && hasPeriodoFim) || // Financeira + UF + Período
      (hasFaixaScore && hasPeriodoInicio && hasPeriodoFim); // Faixa de Score + Período

    if (!hasValidCombination) {
      toastr.warning(
        "Atenção",
        "Preencha uma das combinações válidas: Chassi, Financeira + Período (máximo 30 dias), Financeira + UF + Período (máximo 30 dias) ou Faixa de Score + Período (máximo 30 dias)."
      );
      return false;
    }

    // Validação de datas quando preenchidas
    if (hasPeriodoInicio && hasPeriodoFim) {
      const dataInicio = new Date(MaskDate.TO_DATABASE(values.periodoInicio));
      const dataFim = new Date(MaskDate.TO_DATABASE(values.periodoFim));

      // Verificar se a data final é maior ou igual à data inicial
      if (dataFim < dataInicio) {
        toastr.warning("Atenção", "A data final deve ser maior ou igual à data inicial.");
        return false;
      }

      // Verificar se o intervalo é de no máximo 30 dias
      const diffTime = Math.abs(dataFim - dataInicio);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays > 30) {
        toastr.warning("Atenção", "O período máximo permitido é de 30 dias.");
        return false;
      }
    }

    return true;
  }

  formSubmit(values) {
    // Validar o formulário antes de enviar
    if (!this.validateForm(values)) {
      return;
    }

    var props = this.props;
    Promise.resolve(
      api.Configuracao.getImagensAnalisadas(
        values.chassi,
        values.faixaScore,
        MaskDate.TO_DATABASE(values.periodoInicio),
        MaskDate.TO_DATABASE(values.periodoFim),
        values.financeira && values.financeira.id ? values.financeira.id : values.financeira,
        values.uf
      )
    )
      .then((ret) => {
        this.props.onListLoad(ret);
      })
      .catch(function (resp) {
        if (resp === "Unauthorized" || resp === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  }

  exportToExcel = () => {
    if (!this.props.all || this.props.all.length === 0) {
      toastr.warning("Atenção", "Não há dados para exportar.");
      return;
    }

    // Definir cabeçalhos
    const Heading = [["Financeira", "Nr Contrato", "Chassi", "Data Validação", "Nome do Arquivo", "Score"]];

    // Mapear os dados
    const data = this.props.all.map((item) => [item.razaoSocial, item.numero, item.chassi, MaskDate.TO_BR_DATETIME(item.dataValidacao), item.nome, item.scoreValidacao]);

    // Criar planilha
    const ws = XLSX.utils.aoa_to_sheet(Heading);
    XLSX.utils.sheet_add_json(ws, data, {
      origin: "A2",
      skipHeader: true,
    });

    // Criar workbook e fazer download
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "ImagensAnalisadas");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), "ImagensAnalisadas.xlsx");
  };

  detalhar(item) {
    var props = this.props;
    Promise.resolve(api.Configuracao.getImagemAnalisada(item.idImagem))
      .then((ret) => {
        this.props.dispatch(change("AnaliseImagemForm", "detFinanceira", ret[0].razaoSocial));
        this.props.dispatch(change("AnaliseImagemForm", "detContrato", ret[0].numero));
        this.props.dispatch(change("AnaliseImagemForm", "detChassi", ret[0].chassi));
        this.props.dispatch(change("AnaliseImagemForm", "detDataValidacao", MaskDate.TO_BR_DATETIME(ret[0].dataValidacao)));
        this.props.dispatch(change("AnaliseImagemForm", "detNomeArquivo", ret[0].nome));
        this.props.dispatch(change("AnaliseImagemForm", "detScore", ret[0].scoreValidacao));
        this.props.dispatch(change("AnaliseImagemForm", "detPalavrasPesquisadas", JSON.parse(ret[0].resultadoValidacao).keywords.join(", ")));
        this.props.dispatch(change("AnaliseImagemForm", "detPalavrasEncontradas", JSON.parse(ret[0].resultadoValidacao).keywordsFound.join(", ")));
        this.props.dispatch(change("AnaliseImagemForm", "detOcr", JSON.parse(ret[0].resultadoValidacao).textContent.trimStart()));
        this.setState({ detalhar: ret });
      })
      .catch(function (resp) {
        if (resp === "Unauthorized" || resp === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  }

  handleClickImage = () => (ev) => {
    ev.preventDefault();
    toastr.info("Aguarde", "Processando arquivo...", {
      timeOut: 0,
      component: () => {
        return <BeatLoader size={15} margin={2} color={"#58abc3"} loading={true} />;
      },
    });
    Promise.resolve(api.Contracts.getImage(this.state.detalhar[0].idContrato))
      .then((response) => {
        toastr.removeByType("info");
        fileDownload(response, this.state.detalhar[0].nome);
      })
      .catch((e) => {
        console.log(e);
        toastr.removeByType("info");
      });
  };

  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        <Title routes={this.props.routes} params={this.props.params} description="Análise de imagens de contratos" />
        <div className="content">
          <div className="row">
            <div className="col-lg-12">
              <div className="hpanel">
                {!this.state.detalhar ? (
                  <>
                    <div className="panel-heading">
                      <div className="panel-tools">
                        {((this.props.currentUser.perfis.some((item) => item == "ALIAS") && this.props.currentUser.funcionalidades.includes(95)) ||
                          (!this.props.currentUser.perfis.some((item) => item == "ALIAS") && this.props.currentUser.funcionalidades.includes(51))) && (
                          <Link className="btn btn-xs btn-info" to={`/alias/configurarPalavras`}>
                            {" "}
                            <SvgIcon size={20} icon={wrench} />
                            Configurar Palavras
                          </Link>
                        )}
                      </div>
                      Realizar Consulta
                    </div>
                    <div className="panel-body">
                      <form className="form-horizontal" onSubmit={handleSubmit(this.formSubmit.bind(this))}>
                        <div className="row">
                          {this.props.currentUser.perfis.some((item) => item == "ALIAS") ? (
                            <>
                              <div className="col-md-1">
                                <Field name="uf" label="UF" data={this.props.ufSystem} textField="sigla" valueField="sigla" component={SelectField} type="text" blank={true} />
                              </div>
                              <div className="col-md-4">
                                <Field
                                  name="financeira"
                                  label="Financeira"
                                  data={this.props.allCompanies}
                                  credor={true}
                                  textField="razaoSocialCnpj"
                                  valueField="id"
                                  component={DropdownListField}
                                  type="text"
                                />
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="col-md-1">
                                <Field name="uf" label="UF" data={this.props.currentUser.ufs.slice(1)} textField="sigla" valueField="sigla" component={SelectField} type="text" blank={true} />
                              </div>
                              <div className="col-md-4">
                                <Field
                                  name="financeira"
                                  blank={true}
                                  label="Financeira"
                                  credor={true}
                                  data={this.props.companies}
                                  textField="razaoSocial"
                                  valueField="id"
                                  component={DropdownListField}
                                  type="text"
                                />
                              </div>
                            </>
                          )}

                          <div className="col-md-3">
                            <Field name="chassi" label="Chassi" component={TextField} type="text" maxlength={17} />
                          </div>
                          <div className="col-md-2">
                            <Field
                              name="faixaScore"
                              label="Faixa de Score"
                              blank={true}
                              data={[
                                { id: "1", name: "Alto (maior ou igual a 0.75)" },
                                { id: "2", name: "Médio (entre 0.5 e 0.74)" },
                                { id: "3", name: "Baixo (menor ou igual a 0.49)" },
                              ]}
                              component={SelectField}
                              type="text"
                              valueField="id"
                              textField="name"
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-2">
                            <Field
                              name="periodoInicio"
                              label="Período início"
                              validate={[FieldValidation.date]}
                              normalize={FieldNormalize.DATE}
                              placeholder="00/00/0000"
                              data={this.props.dataValidacao}
                              component={TextDatePickerField}
                              type="text"
                              inline={false}
                            />
                          </div>
                          <div className="col-md-2">
                            <Field
                              name="periodoFim"
                              label="Período fim"
                              validate={[FieldValidation.date]}
                              normalize={FieldNormalize.DATE}
                              placeholder="00/00/0000"
                              data={this.props.dataValidacao}
                              component={TextDatePickerField}
                              type="text"
                              inline={false}
                            />
                          </div>
                          <div className="col-lg-2 align-self-end form-group">
                            <button className="btn btn-info" type="submit" disabled={this.state.pesquisando}>
                              {this.state.pesquisando ? "Aguarde..." : "Filtrar"}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="hpanel">
                          <div className="panel-heading">
                            <div className="panel-tools">
                              <button className="btn btn-default btn-sm" onClick={this.exportToExcel} disabled={!this.props.all || this.props.all.length === 0}>
                                <SvgIcon icon={fileExcelO} />
                              </button>
                            </div>
                            Imagens Analisadas
                          </div>
                          <div className="panel-body">
                            <div className="table-responsive">
                              <ReactTable
                                className="-striped -highlight"
                                defaultPageSize={20}
                                data={this.props.all}
                                loadingText="Carregando..."
                                noDataText="Nenhum Registro encontrado"
                                rowsText="linhas"
                                showPageSizeOptions={false}
                                minRows={1}
                                showPagination={true}
                                previousText="Anterior"
                                nextText="Próximo"
                                pageText="página"
                                ofText="de"
                                columns={[
                                  {
                                    Header: "Financeira",
                                    accessor: "razaoSocial",
                                    headerClassName: "font-extra-bold",
                                  },
                                  {
                                    Header: "Nr Contrato",
                                    accessor: "numero",
                                    className: "align-middle text-center",
                                    headerClassName: "font-extra-bold",
                                  },
                                  {
                                    Header: "Chassi",
                                    accessor: "chassi",
                                    className: "align-middle text-center",
                                    headerClassName: "font-extra-bold",
                                    width: 160,
                                  },
                                  {
                                    Header: "Data Validação",
                                    accessor: "rowData",
                                    className: "align-middle text-center",
                                    headerClassName: "font-extra-bold",
                                    width: 140,
                                    Cell: (rowData) => {
                                      return (
                                        <div>
                                          <span>{MaskDate.TO_BR_DATETIME(rowData.original.dataValidacao)}</span>
                                          <br />
                                        </div>
                                      );
                                    },
                                  },
                                  {
                                    Header: "Nome do Arquivo",
                                    accessor: "nome",
                                    className: "align-middle text-center",
                                    headerClassName: "font-extra-bold",
                                  },
                                  {
                                    Header: "Score",
                                    accessor: "scoreValidacao",
                                    className: "align-middle text-center",
                                    headerClassName: "font-extra-bold",
                                    width: 120,
                                    Cell: (row) => {
                                      const score = row.value;
                                      let bgColor = "";
                                      if (score >= 0.75) {
                                        bgColor = "#59c25e";
                                      } else if (score >= 0.5) {
                                        bgColor = "#e8e53c";
                                      } else {
                                        bgColor = "#ff5b5b";
                                      }
                                      return (
                                        <div
                                          style={{
                                            backgroundColor: bgColor,
                                            width: "100%",
                                            height: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "black",
                                          }}
                                        >
                                          {score}
                                        </div>
                                      );
                                    },
                                  },

                                  {
                                    Header: "Ação",
                                    className: "align-middle text-center",
                                    headerClassName: "font-extra-bold",
                                    width: 190,
                                    Cell: (row) => (
                                      <div className="btn-group">
                                        <Link className="btn btn-sm btn-default" onClick={() => this.detalhar(row.original)}>
                                          <i className="fas fa-search" /> Detalhar
                                        </Link>
                                      </div>
                                    ),
                                  },
                                ]}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="panel-body">
                    <form className="form-horizontal">
                      <div className="row">
                        <div className="col-md-6">
                          <Field name="detFinanceira" label="Financeira" component={TextField} type="text" disabled />
                        </div>
                        <div className="col-md-2">
                          <Field name="detContrato" label="Nr Contrato" component={TextField} type="text" disabled />
                        </div>
                        <div className="col-md-2">
                          <Field name="detChassi" label="Chassi" component={TextField} type="text" disabled />
                        </div>
                        <div className="col-md-2">
                          <Field name="detDataValidacao" label="Data Validação" component={TextField} type="text" disabled />
                        </div>
                        <div className="col-md-3">
                          <Field name="detNomeArquivo" label="Nome do Arquivo" component={TextField} type="text" disabled />
                        </div>
                        <div className="col-md-1">
                          <Field name="detScore" label="Score" component={TextField} type="text" disabled />
                        </div>
                        <div className="col-md-4">
                          <Field name="detPalavrasPesquisadas" label="Palavras Pesquisadas" component={TextareaField} rows={2} type="text" disabled />
                        </div>
                        <div className="col-md-4">
                          <Field name="detPalavrasEncontradas" label="Palavras Encontradas" component={TextareaField} rows={2} type="text" disabled />
                        </div>
                        <div className="col-md-12">
                          <Field name="detOcr" label="Texto Extraído do Documento" component={TextareaField} type="text" rows={10} disabled />
                        </div>
                        <div className="col-lg-12 align-self-end form-group text-right">
                          <button className="btn btn-info btn-sm" onClick={this.handleClickImage()}>
                            <i className="fas fa-image"></i> Baixar Imagem{" "}
                          </button>
                          <button className="btn btn-default btn-sm" onClick={() => this.setState({ detalhar: null })}>
                            Voltar
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  onListLoad: (payload) => dispatch({ type: ANALISE_IMAGEM_LOAD, payload }),
  onUnload: (payload) => dispatch({ type: ANALISE_IMAGEM_UNLOAD, payload }),
  onUfSystemLoad: (payload) => dispatch({ type: UF_SYSTEM_LOAD, payload }),
  onCompaniesLoad: (payload) => dispatch({ type: ANALISE_IMAGEM_ALL_COMPANIES_LOAD, payload }),
});

const selector = formValueSelector("AnaliseImagemForm");
const mapStateToProps = (state) => ({
  ...state.analiseImagem,
  dataValidacao: selector(state, "dataValidacao"),
  currentUser: state.common.currentUser,
  companies: state.common.companies.length > 0 ? state.common.companies : [],
});

const form = reduxForm({
  form: "AnaliseImagemForm",
});

export default connect(mapStateToProps, mapDispatchToProps)(form(AnaliseImagem));
